import { CardContent, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { useState } from "react";
import FindInvoiceNumberInput from "./FindInvoiceNumberInput";
import CalculateAreaInput from "./CalculateAreaInput";
import CalculateStudentCostInput from "./CalculateStudentCostInput";
import CalculateFeatureInput from "./CalculateFeatureInput";

const DashboardCustomerService = () => {
  const [calculateType, setCalculateType] = useState<string>();

  const showCalculateInput = (type: string) => {
    switch (type) {
      case "area":
        return (
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Calculate Area
            </Typography>

            <CalculateAreaInput />
          </Grid>
        );
      case "studentCost":
        return (
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Calculate Student Cost
            </Typography>

            <CalculateStudentCostInput />
          </Grid>
        );
    }
  };

  return (
    <CardContent>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Calculate Feature
          </Typography>

          <CalculateFeatureInput
            calculateType={calculateType}
            setCalculateType={setCalculateType}
          />
        </Grid>

        {showCalculateInput(calculateType)}

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Find Invoice / Credit Note Info
          </Typography>

          <FindInvoiceNumberInput />
        </Grid>
      </SanitizedGrid>
    </CardContent>
  );
};

export default DashboardCustomerService;
